import React from 'react';
import { Typography, Breadcrumbs } from '@material-ui/core';
import { KeyboardArrowRight, Home } from '@material-ui/icons';
import PropTypes from 'prop-types';
import styles from 'styles/components/breadcrumbs.module.scss';
import Link from './link';

const Breadcrumb = ({ links }) => {
    return (
        <div className={styles.root}>
            <Breadcrumbs
                separator={<KeyboardArrowRight fontSize="small" />}
                aria-label="breadcrumb"
            >
                <Link color="inherit" href="/">
                    <Home fontSize="small" />
                </Link>

                {links.map((link) => {
                    if (link.href) {
                        return (
                            <Link
                                key={link.href}
                                color="inherit"
                                href={link.href}
                                as={link.as}
                            >
                                {link.text}
                            </Link>
                        );
                    }
                    return (
                        <Typography key={link.text} color="textPrimary">
                            {link.text}
                        </Typography>
                    );
                })}
            </Breadcrumbs>
        </div>
    );
};

Breadcrumb.propTypes = {
    links: PropTypes.array.isRequired,
};

export default React.memo(Breadcrumb);
